/**
 * Created by cd01 on 2017/8/4.
 * 企业管理页面
 */
{
    angular.module('interfaceModule')
        .controller('CompanyController', CompanyController)
    CompanyController.$inject = ['$scope',"$state",'$http','$stateParams','utils.constant','alertControl','utils.platform',
        '$timeout','utils.common','requestHandler','ModalWindow','utils.currentUser','request.order'];
    function CompanyController($scope,$state,$http,$stateParams,constant,alertControl,platform,$timeout,common,requestHandler,ModalWindow,currentUser,orderRequest){
        let vm=this;
        let collect = {
            "activate": activate,
            'clickTab': clickTab,   //点击导航栏
            'clickTabItem':'历史月打印统计',    //点击选择导航界面。
            'getCompanyInfo':getCompanyInfo,

            "companyMonthCount": companyMonthCount,    //公司月统计
            'deptMonthCount':deptMonthCount ,   //部门月统计
            'getDeptStaffMonthCount':getDeptStaffMonthCount,  //历史月部门员工统计
            'oneDeptCurMonCount': oneDeptCurMonCount,  //当前月某个部门统计
            'deptmentInfo':null,               //部门信息
            'companyPay':companyPay,            //支付
            'goBackTable':goBackTable,
            'table2Close' : table2Close,           //关闭表格
            'table3Close' : table3Close,
            'table4Close' : table4Close,
            // 'getStaffOrderInfo': getStaffOrderInfo,    //部门所有员工订单详细信息
            'payClose':payClose,
            'getDeptStaff': getDeptStaff ,  //部门员工
            'addDept': addDept,
            'deleteDept':deleteDept,
            'updateDept':updateDept,
            'clickAddStaff':clickAddStaff,          //添加员工
            'clickStaffInfoChange': clickStaffInfoChange, //点击修改
            'clickDeleteStaff' : clickDeleteStaff,   //点击注销
            'cancelBtn': cancelBtn,
            'sureBtn': sureBtn,
            "hide":true,
            "userId": null,
            "companyInfo":null,
            "lackShow": true,        //是否显示欠费
            'companyMonthCountInfo':null,
            'deptMonthCountInfo':null,
            'companyCurMonCountInfo' : null,
            'staffCurMonCountInfo' : null,

            //表格
            'tCompanyCountTable': true,
            'tMonthDeptTable':false,           //指定月每个部门的统计表
            'tMonthDeptStaffTable':false,      //指定月和部门的员工的打印详情表
            'tDeptSortTable': true,
            'tDeptStaffTable': false,          //指定部门员工信息表
            'tMonthStaffPrintOrdersTable':false, //历史月某个员工打印订单详情表
            'tMonthStaffRefundOrdersTable':false, //历史月某个员工退款订单详情表
            'tCompanyCurMonCountTable': true,
            'tStaffCurMonCountTable': false,
            'tStaffPrintOrdersTable' : false,
            'tStaffRefundOrdersTable' : false,
            'tCompanyDayCountTable' : true,

            'statisticalMonth': null,          //选择统计的月份
            'statisticalDeptment':null,    //选择统计的部门
            'deptStaffOrderInfo': null,    //部门员工订单信息
            'deptStaffInfo': null,         //部门员工信息
            'StaffChangeInfo':null,        //修改的员工信息
            'deptChangeInfo':null,         //修改的部门的信息
            'selectDeptment':null,      //选择的部门

            //弹窗
            'tanWindows': false,
            'addStaffWindows': false,
            'changeStaffWindows': false,
            'addDeptWindows':false,
            'changeDeptWindows':false,

            'applicationInfo':null,  //申请者信息
            'addStaffToDept': null,   //进行添加员工的部门
            'addStaffToDeptName':null,
            'addDeptInfo':{},      //添加的部门信息
            'backDeptid': null,    //添加部门系统生成返回来的部门id

            'searchYear1': null,
            'seachHisMonCount':seachHisMonCount,

            'serchStaffId':null,
            'searchStaff': searchStaff,

            'allCheckValue':false,
            'allCheck':allCheck,
            'singleCheck':singleCheck,
            'applicant':applicant,
            'CheckNum': '0',
            'isSelect':false,

            'noCompanyInfo':false,

            'userPrintOrders':userPrintOrders,   //获取员工打印的订单
            'userRefundOrders' : userRefundOrders, ///获取员工退款的订单
            'staffPrintOrdersInfo' : null,
            'staffRefundOrdersInfo' : null,
            'staffMonthPrintOrdersInfo' : null,
            'staffMonthRefundOrdersInfo' : null,

            'companyDayCount' : companyDayCount,
            'deptmentDayOrders':deptmentDayOrders,
            'dayCountQueryDay':null,
            'tDeptmentDayPrintOrdersTable': false,
            'tDeptmentDayRefundOrdersTable' : false,
            'deptmentDayPrintOrdersInfo' : null,
            'deptmentDayRefundOrdersInfo' :null,

            deptNametoIdArry:[],     //部门名称和部门标识号配对集； ==> 用不到这个啊！


        };

        let tabItem = {
            'tab0': '历史月打印统计',
            'tab1': '当前月统计',
            'tab2': '日统计',
            'tab3': '部门-员工操作'
        }
        vm.collect=collect;
        vm.tabItem = tabItem;
        activate();              //这样调用函数一定要记得加上后面的括号（）；

        function activate(){

            console.log('进来了企业管理页面！');
            collect.userId = $stateParams.userId;
            getCompanyInfo(0);

        }
        //用userid 获取公司信息
        function getCompanyInfo(init){
            var _data = [{
                'userid': $stateParams.userId
            }];
            console.log('要传的数据：',_data);
            let paramsStr='companyuserpay='+JSON.stringify(_data);
            //用userid 获取公司信息
            requestHandler.simpleRequest(constant.action.companyinfoquery,paramsStr,
                function successCallback(responce){
                    console.log('成功',responce);
                    $('#tab').find('li').eq(init).addClass('active');
                    collect.companyInfo = responce.data[0].companyinfo;

                    if(collect.companyInfo.debtmonth==0){
                        collect.lackShow = false
                    }
                    //配对部门名称和部门标识号    ==》用不到它，暂时放在这里不删除
                    for(var i=0; i<collect.companyInfo.deptment.length; i++){
                        // collect.deptNametoIdArry
                        var _obj = {};
                        _obj.key = collect.companyInfo.deptment[i].deptid;
                        _obj.value = collect.companyInfo.deptment[i].deptname;
                        collect.deptNametoIdArry.push(_obj);
                    };

                    companyMonthCount();

                },
                function errorCallback(responce){
                    console.log('失败',responce);
                }
            );
        };

        //获取所有部门信息
        function getAlldeptmentInfo(){
            var _data = [{
                "deptoperation" : "1",          //查询
                "querytype" : "1" ,                 //查询企业所有信
                "companyid": collect.companyInfo.companyid
            }];
            console.log(_data);
            let paramsStr ='deptinfo=' + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.deptoperation, paramsStr,
                function successCallback(responce){
                    console.log('所有部门信息：',responce);
                    if(responce.data[0].result == 1){
                        collect.deptmentInfo = responce.data[0].department;
                    }

                },
                function errorCallback(responce){
                    console.log('失败',responce);
                }
            )
        };

        //点击导航栏
        function clickTab(item,$index){
            console.log('item', item);
            console.log($index);
            $('#tab').find('li').removeClass('active');
            $('#tab').find('li').eq($index).addClass('active');
            collect.clickTabItem = item;
            if($index == 0){

            }else if($index == 3){
                //获取部门信息：
                getAlldeptmentInfo();
            }else if ($index == 1 ){
                //获取公司当前月统计
                getCompanyCurMonCount()
            }else if($index == 2){
                //获取日统计
                if(!collect.companyDayCountInfo){
                    companyDayCount();
                }

            }
        }

        //表格返回
        function goBackTable(num){
            if(num == 1){
                collect.tMonthDeptTable = false;
                collect.tCompanyCountTable = true;

            }else if(num == 2){
                collect.tMonthDeptStaffTable = false;
                collect.tMonthDeptTable = true;

            }else if(num == 3){
                collect.tDeptStaffTable = false;
                collect.tDeptSortTable = true;

            }else if(num == 4){
                collect.tStaffCurMonCountTable = false;
                collect.tCompanyCurMonCountTable = true;
            }else if(num == 5){
                collect.tStaffPrintOrdersTable = false;
                collect.tStaffCurMonCountTable = true;
            }else if(num == 6){
                collect.tStaffRefundOrdersTable = false;
                collect.tStaffCurMonCountTable = true;
            }else if(num == 7){
                collect.tDeptmentDayPrintOrdersTable = false;
                collect.tCompanyDayCountTable = true;
            }else if(num == 8){
                collect.tDeptmentDayRefundOrdersTable = false;
                collect.tCompanyDayCountTable = true;
            }else if(num == 9){
                collect.tMonthStaffPrintOrdersTable = false;
                collect.tMonthDeptStaffTable = true;
            }else if(num == 10){
                collect.tMonthStaffRefundOrdersTable = false;
                collect.tMonthDeptStaffTable = true;
            }
        }

        //点击查找公司历史月统计
        function seachHisMonCount(){
            companyMonthCount();
        }
        //公司历史月统计
        function companyMonthCount(){
            var _date = new Date();
            var _year = _date.getFullYear();
            if(!collect.searchYear1){
                collect.searchYear1 = _year;
            }
            console.log('检测企业标识号：',collect.companyInfo.companyid);
            // console.log('检测企业标识号：',JSON.parse(collect.companyInfo.companyid));
            var _data = [{
                'querytype': 1,
                'year': collect.searchYear1,
                'companyid': collect.companyInfo.companyid
            }];
            console.log('传参',_data);
            let paramsStr ='userorderinfo=' + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.usermanagerorderquery, paramsStr,
                function successCallback(responce){
                    console.log('公司月付信息：',responce);

                    if(responce.data[0].result == 1){
                        collect.companyMonthCountInfo = responce.data[0].company;
                        collect.noCompanyInfo = false;
                    }else{
                        collect.companyMonthCountInfo = null;
                        collect.noCompanyInfo = true;
                    }

                },
                function errorCallback(responce){
                    console.log('失败',responce);
                }
            )
        }

        //指定月，各部门月统计
        function deptMonthCount(m,$index,evt){
           // table2Close();
            collect.statisticalMonth = m.counttime;
            console.log('m:',m);
            console.log('$index:', $index);
            console.log('事件', evt);
            var _date = new Date();
            var _year = _date.getFullYear();
            var _data = [{
                'querytype': 5,
                'year': _year,
                'month': m.counttime *1,
                'companyid': collect.companyInfo.companyid
            }];
            console.log('传参',_data);
            let paramsStr ='userorderinfo=' + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.usermanagerorderquery, paramsStr,
                function successCallback(responce){
                    console.log('各个部门月付信息：',responce);
                    collect.deptMonthCountInfo = responce.data[0].deptment;
                    collect.tMonthDeptTable = true;   //显示表格
                    collect.tCompanyCountTable = false;
                },
                function errorCallback(responce){
                    console.log('失败',responce);
                }
            )
        }
        //指定月，指定部门，员工的打印订单统计
        function getDeptStaffMonthCount(m,$index,event){
            console.log('点击的部门信息',m);
            var _data = [{
                "querytype" : 6,
                "year" : m.year,
                "month" : m.counttime,
                "companyid": collect.companyInfo.companyid,
                "deptid" : m.deptid
            }];
            let paramsStr = 'userorderinfo=' + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.usermanagerorderquery, paramsStr,
                function successCallback(responce){
                    collect.deptStaffMonthCountInfo = responce.data[0].staffCountInfo;
                    collect.tMonthDeptStaffTable = true;
                    collect.tMonthDeptTable = false;
                }
            )

        }

        //指定月和部门，部门员工的订单详情
        // function getStaffOrderInfo(m,$index,event){
        //     collect.statisticalDeptment = m.deptname;
        //     console.log('m:',m);
        //     console.log('$index:', $index);
        //     console.log('员工事件', event);
        //     var _date = new Date();
        //     var _year = _date.getFullYear();
        //     var _data = [{
        //         "querytype": 4,
        //         "year": _year,
        //         "month": m.counttime,
        //         "companyid": collect.companyInfo.companyid,
        //         "deptid": m.deptid
        //     }];
        //     console.log('传的参数',_data);
        //     let paramsStr ='userorderinfo=' + JSON.stringify(_data);
        //     requestHandler.simpleRequest(constant.action.usermanagerorderquery, paramsStr,
        //         function successCallback(responce){
        //             console.log('部门员工订单信息：',responce);
        //             collect.deptStaffOrderInfo = responce.data[0].orderinfo;
        //             collect.tMonthDeptStaffTable = true;      //显示表格
        //             collect.tMonthDeptTable = false;
        //         },
        //         function errorCallback(responce){
        //             console.log('失败',responce);
        //         }
        //     )
        // }

        //当前月各个部门统计
        function getCompanyCurMonCount(){
            let _date = new Date();
            let _year = _date.getFullYear();
            let _month = _date.getMonth() + 1;
            var _data = [{
                "querytype" : 1,
                "year" : 2017,
                "month" : 11,
                "companyid" : collect.companyInfo.companyid
            }];
            let paramsStr = 'companystatement=' + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.companyCurMonCount, paramsStr,
                function successCallback(responce){
                    console.log('当期月信息',responce);
                    if(responce.data[0].result == 1){
                        collect.companyCurMonCountInfo = responce.data[0].responce;

                    }

                },
                function errorCallback(responce){

                }
            )
        }
        //当前月某个部门员工统计
        function oneDeptCurMonCount(item,index,event){
            console.log('item',item);
            console.log('index',index);
            console.log('event',event);
            let _date = new Date();
            let _year = _date.getFullYear();
            let _month = _date.getMonth() + 1;
            var _data = [{
                "querytype" : 2,
                "year" : 2017,
                "month" : 11,
                "companyid" : collect.companyInfo.companyid,
                "deptid" : item.deptid
            }];
            let paramsStr = 'companystatement=' + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.companyCurMonCount, paramsStr,
                function successCallback(responce){
                    console.log('当期月信息',responce);
                    if(responce.data[0].result == 1){
                        collect.staffCurMonCountInfo = responce.data[0].responce;
                        collect.tCompanyCurMonCountTable = false;
                        collect.tStaffCurMonCountTable = true;

                    }

                },
                function errorCallback(responce){

                }
            )
        }
        //某个员工打印订单
        function userPrintOrders(type,item,index,event){
            console.log('item',item);
            if (type == 1){ //日查询

            }else{ //月查询
                var _data = [{
                    "querytype": 1,
                    "userid" : item.userid,
                    "companyid" : collect.companyInfo.companyid,
                    "deptid" : item.deptid,
                    "year" : item.year,
                    "month" :item.counttime
                }];
            }
            let paramsStr = 'staffInfo=' + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.staffPrintOrders, paramsStr,
                function successCallback(responce){
                    if (responce.data[0].result == 1){
                        if (type == 1){  //日查询

                        }else if (type == 2){  //当前月
                            collect.staffPrintOrdersInfo = responce.data[0].responce;
                            collect.tStaffCurMonCountTable = false;
                            collect.tStaffPrintOrdersTable = true;

                        }else if(type == 3){   //历史月
                            collect.staffMonthPrintOrdersInfo = responce.data[0].responce;
                            collect.tMonthStaffPrintOrdersTable = true;
                            collect.tMonthDeptStaffTable = false;
                        }
                    }
                }
            )
        }
        //某个员工退款订单
        function userRefundOrders(type,item,index,event){
            if (type == 1){ //日查询

            }else{ //月查询
                var _data = [{
                    "querytype": 1,
                    "userid" : item.userid,
                    "companyid" : collect.companyInfo.companyid,
                    "deptid" : item.deptid,
                    "year" : item.year,
                    "month" :item.counttime
                }];
            }
            let paramsStr = 'staffInfo=' + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.staffRefundOrders, paramsStr,
                function successCallback(responce){
                    if (responce.data[0].result == 1){
                        if (type == 1){  //日查询

                        }else if (type == 2){  //当前月
                            collect.staffRefundOrdersInfo = responce.data[0].responce;
                            collect.tStaffCurMonCountTable = false;
                            collect.tStaffRefundOrdersTable = true;

                        }else if(type == 3){   //历史月
                            collect.staffMonthRefundOrdersInfo = responce.data[0].responce;
                            collect.tMonthStaffRefundOrdersTable = true;
                            collect.tMonthDeptStaffTable = false;
                        }
                    }
                }
            )

        }

        //日统计
        function companyDayCount(num){
            if (collect.dayCountQueryDay == null){  //这里的判断条件是不是应该用日期？？？
                var _date = new Date();
                var _year = _date.getFullYear();
                var _month = _date.getMonth() + 1;
                var _day = _date.getDate();
                collect.dayCountQueryDay = _year + '-' + _month + '-' + _day;
            }else{
                //把日历日期赋值给它。
                collect.dayCountQueryDay = document.getElementsByClassName('day1')[0].getAttribute('datepicker');
            }
            // console.log('日期',document.getElementsByClassName('day1')[0].getAttribute('datepicker'));
            var _data = [{
                "querytype" : 1,
                "companyid" : collect.companyInfo.companyid,
                "queryday" :  collect.dayCountQueryDay
                // "queryday" : "2017-11-30"
            }];
            let paramsStr = 'companystatement=' + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.companyDayCount, paramsStr,
                function successCallback(responce){
                    if (responce.data[0].result == 1){
                        collect.companyDayCountInfo = responce.data[0].responce;
                    }
                }
            )
        }
        //部门某日打印/退款订单详情
        function deptmentDayOrders(type,item,index,event){
            var _data = [{
                "querytype" : type,
                "companyid" : collect.companyInfo.companyid,
                "deptid" : item.deptid,
                "queryday" : item.counttime
            }];
            let paramsStr = 'companystatement=' + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.companyDayCount, paramsStr,
                function successCallback(responce){
                    if(responce.data[0].result == 1){
                        if (type == 3){   //打印订单
                            collect.deptmentDayPrintOrdersInfo = responce.data[0].responce;
                            collect.tCompanyDayCountTable = false;
                            collect.tDeptmentDayPrintOrdersTable = true;
                        }else if(type == 4){  //退款订单
                            collect.deptmentDayRefundOrdersInfo = responce.data[0].responce;
                            collect.tCompanyDayCountTable = false;
                            collect.tDeptmentDayRefundOrdersTable = true;
                        }
                    }else if(responce.data[0].result == 0){

                    }
                }
            )
        }

        //点击支付：
        function companyPay(m,$index,event){
            console.log('m:',m);
            console.log('$index:', $index);
            console.log('支付事件', event);
            collect.hide =false;
        }

        //收起表格
        function table2Close(){
           // collect.tMonthDeptTable = false;
           // collect.tMonthDeptStaffTable = false;
        }
        function table3Close(){
           // collect.tMonthDeptStaffTable = false;
        }
        function table4Close(){
           // collect.tDeptStaffTable = false;
        }
        //隐藏支付界面
        function payClose(){
            collect.hide = true;
        }

        //获取部门员工
        function getDeptStaff(m,$index,event){
            //console.log('m:',m);
            //console.log('$index:', $index);
            var _data = [{
                "querytype": 4,
                "companyid":  collect.companyInfo.companyid,
                "deptid": m.deptid
            }];
            console.log(_data);
            let paramsStr ='companyuserinfo=' + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.usermanageroperation, paramsStr,
                function successCallback(responce){
                    console.log('部门员工信息：',responce);
                    collect.deptStaffInfo = responce.data[0].userinfo;
                    collect.tDeptStaffTable = true;
                    collect.tDeptSortTable = false;
                },
                function errorCallback(responce){
                    console.log('失败',responce);
                }
            )
        }

        //添加部门
        function addDept(){
            console.log('添加部门');
            collect.tanWindows = true;
            collect.addDeptWindows = true;
            //清空弹窗填写的信息
            collect.addDeptInfo.deptname = null;
            collect.addDeptInfo.deptphone = null;
            collect.addDeptInfo.deptfax = null;
        };
        //删除部门
        function deleteDept(m,$index){
            console.log('点击对象',m);
            console.log('对象的下标',$index);
            if(m.dept_staff_num > 0){
                let alert=alertControl.show('',
                    "该部门还有员工，不能进行注销",
                    [{
                        'title':'确定',
                        'action':function(){
                            alert.close();
                            return ;
                        }
                    }]
                );
            }else{
                console.log('进行删除');
                let alert=alertControl.show('',
                    "是否确认要删除该部门：" + m.deptname,
                    [{
                        'title':'确定',
                        'action':function(){
                            alert.close();
                            //操作删除
                            var _data = [{
                                "deptoperation" : "2",
                                'companyid': m.companyid,
                                'deptid': m.deptid,
                                'deptname': m.deptname,
                                'valid': 0
                            }];
                            console.log('要传的参数',_data);
                            let params = 'deptinfo=' + JSON.stringify(_data);
                            requestHandler.simpleRequest(constant.action.deptoperation, params,
                                function(responce){
                                    console.log('成功删除',responce);
                                    if(responce.data[0].result == 1){
                                        let alert=alertControl.show('',
                                            "删除成功",
                                            [{
                                                'title': '确定',
                                                'action': function(){
                                                    alert.close();
                                                    getAlldeptmentInfo();
                                                }
                                            }]
                                        )
                                    }
                                },
                                function(responce){
                                    console.log('删除失败',responce);
                                    if(responce.data[0].result == 0){
                                        let alert=alertControl.show('',
                                            "删除失败",
                                            [{
                                                'title': '确定',
                                                'action': function(){
                                                    alert.close();
                                                }
                                            }]
                                        )
                                    }
                                }
                            )

                        }
                    },{
                        'title':'取消',
                        'action':function(){
                            alert.close();
                            return ;
                        }
                    }]
                );
            }
        }
        //修改部门
        function updateDept(m,$index){
            console.log('修改部门',m);
            collect.deptChangeInfo = m;
            collect.tanWindows = true;
            collect.changeDeptWindows = true;

        }

        //点击添加员工选项,获取申请员工的数据
        function clickAddStaff(m,$index){
            console.log(m);
            collect.addStaffToDept = m.deptid;
            collect.addStaffToDeptName = m.deptname;
            console.log('添加员工的部门标识号',collect.addStaffToDept);
            collect.addStaffWindows = true;
            collect.tanWindows = true;
            //获取申请企业用户的员工信息
            console.log('公司信息：',collect.companyInfo)
            getApplicantInfo();
        };
        //获取申请者信息
        function getApplicantInfo(){
            console.log('调用获取申请者信息函数');
            var _data = [{
                'companyid': collect.companyInfo.companyid,
                'querytype': 1,
            }];
            console.log('要传的信息',_data);
            let paramsStr =  'companyregister=' + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.companyregister, paramsStr ,
                function(responce){
                    console.log('获取申请信息',responce);
                    if (responce.data[0].result == 1){

                        collect.applicationInfo = null;
                        collect.applicationInfo = responce.data[0].userinfo;
                    }else if(responce.data[0].result == 0){
                        collect.applicationInfo = null;
                    }
                },
                function(responce){
                    console.log('不能获取申请信息',responce);
                }
            )
        };
        //移除申请者
        function applicant(){
            var inputEle = angular.element("input:checkbox[name='user']:checked");
            var temp = [];
            angular.forEach(inputEle,function(item){
                //按需去对应的数据
                var itemValue = angular.fromJson(item.value);
                temp.push(itemValue.userid);
            })
            console.log('选中的申请者',temp);
            if(temp.length == 0){
                let alert=alertControl.show('',
                    "请勾选要删除的申请者",
                    [{
                        'title':'确定',
                        'action':function(){
                            alert.close();
                            return ;
                        }
                    }]
                );
            }else{
                let alert=common.alert('',
                    '确认移除选中的员工？',
                    [{
                        'title':'取消',
                        'action':function(){
                            alert.close();
                        }
                    },{
                        'title':'确认',
                        'action':function(){
                            alert.close();
                            var _data = [{
                                'querytype': 3,
                                'companyid': collect.companyInfo.companyid,
                                'userid': temp,
                            }];
                            console.log('要传的数据',_data);
                            let paramsStr =  'companyregister=' + JSON.stringify(_data);
                            requestHandler.simpleRequest(constant.action.companyregister, paramsStr ,
                                function(responce){
                                    console.log('删除申请结果',responce);
                                    if (responce.data[0].result == 1){
                                        let alert=alertControl.show('',
                                            responce.data[0].msg,
                                            [{
                                                'title':'确定',
                                                'action':function(){
                                                    alert.close();
                                                    getCompanyInfo(1);
                                                    var m = {};
                                                    m.deptid = collect.addStaffToDept;
                                                    getDeptStaff(m);
                                                    getApplicantInfo();
                                                }
                                            }]
                                        );
                                    }else{
                                        let alert=alertControl.show('',
                                            responce.data[0].msg,
                                            [{
                                                'title':'确定',
                                                'action':function(){
                                                    alert.close();
                                                }
                                            }]
                                        );
                                    }
                                },
                                function(responce){

                                }
                            )
                        }
                    }]);


            }

        }

        //点击修改员工信息选项
        function clickStaffInfoChange(m,$index){
            collect.tanWindows = true;
            collect.changeStaffWindows = true;
            console.log('m',m);
            collect.StaffChangeInfo = m;
            collect.selectDeptment = m.deptid;


        }

        //点击注销某员工
        function clickDeleteStaff(m,$index){
            console.log('m',m);
            let alert = alertControl.show('',
                '真的要注销员工'+ m.userid + '吗？',
                [
                    {
                        'title':'确定',
                        'action':function(){
                            alert.close();
                            console.log('进行注销');
                            sureDeleteStaff(m,$index);

                        }
                    },
                    {
                        'title':'取消',
                        'action':function(){
                            alert.close();
                            return ;
                        }
                    }
                ],
            );
        }
        //确认注销
        function sureDeleteStaff(m,$index){
            console.log('m',m);
            var _data = [{
                'querytype': 2,
                'companyid': collect.companyInfo.companyid,
                'deptid': m.deptid,
                'userid': m.userid,
            }];
            console.log('要传的数据', _data);
            let params = 'companyuserinfo=' + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.usermanageroperation, params,
                function(responce){
                    console.log(responce);
                    getCompanyInfo(1);
                    getDeptStaff(m);

                },
                function(responce){
                    console.log(responce);
                }
            )
        }


        //点击取消按钮
        function cancelBtn(type){
            collect.addStaffToDept = null;
            collect.tanWindows = false;
            if (type == 1){
                collect.addStaffWindows = false
            }else if(type==2){
                collect.changeStaffWindows = false;
            }else if(type==3){
                collect.addDeptWindows = false;
            }else if(type == 4){
                collect.changeDeptWindows = false;
                getAlldeptmentInfo();
            }

        }
        //点击确认按钮：
        function sureBtn(type){
            if(type == 1){
                //添加员工
                var inputEle = angular.element("input:checkbox[name='user']:checked");
                var temp = [];
                angular.forEach(inputEle,function(item){
                    //按需去对应的数据
                    var itemValue = angular.fromJson(item.value);
                    temp.push(itemValue.userid);
                })
                console.log('选中的申请者',temp);
                var _data = [{
                    'querytype': 5,
                    'companyid': collect.companyInfo.companyid,
                    'deptid': collect.addStaffToDept,
                    'userid': temp,
                }];
                console.log('要传的数据',_data);
                let paramsStr = 'companyuserinfo=' + JSON.stringify(_data);
                requestHandler.simpleRequest(constant.action.usermanageroperation, paramsStr,
                    function(responce){
                        console.log(responce);
                        if(responce.data[0].result==1){
                            let alert=alertControl.show('',
                                responce.data[0].msg,
                                [{
                                    'title':'确定',
                                    'action':function(){
                                        alert.close();
                                        // getCompanyInfo(1);
                                        getAlldeptmentInfo()
                                        var m = {};
                                        m.deptid = collect.addStaffToDept;
                                        getDeptStaff(m);
                                        getApplicantInfo();
                                    }
                                }]
                            );
                        }else if (responce.data[0].result==0){
                            let alert=alertControl.show('',
                                responce.data[0].msg,
                                [{
                                    'title':'确定',
                                    'action':function(){
                                        alert.close();
                                    }
                                }]
                            );
                        }
                    },
                    function(responce){
                        console.log(responce);
                    }
                )
            }else if(type==2){
                //转移员工所属部门
                var _data = [{
                    'querytype': 1,
                    'companyid': collect.companyInfo.companyid,
                    'deptid': collect.selectDeptment,
                    'userid': collect.StaffChangeInfo.userid,
                }];
                console.log('要传的数据',_data);
                let paramsStr = 'companyuserinfo=' + JSON.stringify(_data);
                requestHandler.simpleRequest(constant.action.usermanageroperation, paramsStr,
                    function(responce){
                        console.log(responce);
                        if(responce.data[0].result==1){
                            let alert=alertControl.show('',
                                responce.data[0].msg,
                                [{
                                    'title':'确定',
                                    'action':function(){
                                        alert.close();
                                        var m = {};
                                        m.deptid = collect.StaffChangeInfo.deptid;
                                        // getCompanyInfo(1);
                                        getAlldeptmentInfo();
                                        getDeptStaff(m);
                                        collect.tanWindows = false;
                                        collect.changeStaffWindows = false;
                                    }
                                }]
                            );
                        }else if (responce.data[0].result==0){
                            let alert=alertControl.show('',
                                responce.data[0].msg,
                                [{
                                    'title':'确定',
                                    'action':function(){
                                        alert.close();

                                    }
                                }]
                            );
                        }
                    },
                    function(responce){
                        console.log(responce);
                    }
                )
            }else if(type==3){
                //添加部门
                console.log('填写的部门信息',collect.addDeptInfo);
                if(collect.addDeptInfo.deptname == null || collect.addDeptInfo.deptname == '' ){
                    let alert = alertControl.show('',
                        '请输入部门名称',
                        [{
                            'title':'确定',
                            'action': function () {
                                alert.close();
                            }
                        }]
                    )
                    return ;
                }
                var _data = [{
                    "deptoperation" : "0",    // 0 ==> 添加
                    'companyid': collect.companyInfo.companyid,
                    'deptname': collect.addDeptInfo.deptname,
                    'phone': collect.addDeptInfo.deptphone,
                    'fax' : collect.addDeptInfo.deptfax,
                }];
                console.log('要传的参数',_data);
                let params = 'deptinfo=' + JSON.stringify(_data);
                requestHandler.simpleRequest(constant.action.deptoperation, params,
                    function(responce){
                        console.log(responce);
                        if(responce.data[0].result==1){
                            collect.backDeptid = responce.data[0].deptid;
                            let alert = alertControl.show('添加部门成功',
                                '部门：' +  collect.addDeptInfo.deptname + ' 的部门标识号为： ' + collect.backDeptid,
                                [{
                                    'title':'确认',
                                    'action': function(){
                                        alert.close();
                                        collect.tanWindows = false;
                                        collect.addDeptWindows = false;
                                        // getCompanyInfo();
                                        getAlldeptmentInfo();

                                    }
                                }]
                            )
                        }else if(responce.data[0].result==0){
                            let alert = alertControl.show('',
                                '添加部门失败',
                                [{
                                    'title':'确认',
                                    'action': function(){
                                        alert.close();
                                    }
                                }]
                            )
                        }

                    },
                    function(responce){
                        console.log(responce);
                    }
                )
            }else if(type == 4){
                console.log('修改部门',collect.deptChangeInfo);
                var _data = [{
                    "deptoperation" : "2",
                    'companyid': collect.deptChangeInfo.companyid,
                    'deptid': collect.deptChangeInfo.deptid,
                    'deptname': collect.deptChangeInfo.deptname,
                    'phone': collect.deptChangeInfo.deptphone,
                    'fax' : collect.deptChangeInfo.deptfax,
                }];
                console.log('要传的参数',_data);
                let params = 'deptinfo=' + JSON.stringify(_data);
                requestHandler.simpleRequest(constant.action.deptoperation, params,
                    function(responce){
                        console.log(responce);
                        if(responce.data[0].result==1){
                            let alert = alertControl.show('',
                                '修改部门成功',
                                [{
                                    'title':'确认',
                                    'action': function(){
                                        alert.close();
                                        collect.tanWindows = false;
                                        collect.changeDeptWindows = false;
                                        // getCompanyInfo();
                                        getAlldeptmentInfo();

                                    }
                                }]
                            )
                        }else if(responce.data[0].result==0){
                            let alert = alertControl.show('',
                                '修改部门失败',
                                [{
                                    'title':'确认',
                                    'action': function(){
                                        alert.close();
                                    }
                                }]
                            )
                        }

                    },
                    function(responce){
                        console.log(responce);
                    }
                )
            }

        }

        //查找员工
        function searchStaff(){
            if(collect.serchStaffId == null || collect.serchStaffId == ''){
                let alert = alertControl.show('',
                    '请输入要查找的员工id',
                    [{
                        'title': '确定',
                        'action': function(){
                            alert.close();
                            return;
                        }
                    }]
                )
            }else{
                var _data = [{
                    'querytype':7,
                    'companyid': collect.companyInfo.companyid,
                    'userid': collect.serchStaffId
                }];
                console.log('要传的数据',_data);
                let params = 'companyuserinfo=' + JSON.stringify(_data);
                requestHandler.simpleRequest(constant.action.usermanageroperation, params,
                    function(responce){
                        console.log(responce);
                        collect.deptStaffInfo = responce.data[0].userinfo;
                        collect.tDeptStaffTable = true;
                    },
                    function(responce){

                    }
                )
            }

        }

        //全选、反全选
        function allCheck(){
            if(!collect.allCheckValue){
                collect.allCheckValue = true;
                $("input[name='user']:checkbox").prop('checked',true);
                collect.CheckNum = collect.applicationInfo.length;
                console.log('选择的数目',collect.CheckNum );
            }else{
                collect.allCheckValue = false;
                $("input[name='user']:checkbox").prop('checked',false);
                collect.CheckNum = '0';
                console.log('选择的数目',collect.CheckNum );
            }
        }
        //单选点击
        function singleCheck(target) {
            console.log('单选点击',target);
            //程序进行都这里时，这个复选框已经是被选中状态/被取消状态了。
            console.log(target.checked);
            if(target.checked == true){
                console.log('点击前是没有选中的');
                collect.CheckNum += 1;
            }else if(target.checked == false){
                console.log('点击前是被选中的');
                collect.CheckNum -= 1;
            };
            if(collect.CheckNum == collect.applicationInfo.length){
                $("input[name='allUsers']:checkbox").prop('checked',true);
            }else{
                $("input[name='allUsers']:checkbox").prop('checked',false);
            }
        };


    }
}